/**
 * FAQ: accordion exclusivo + busca (spec 0108).
 * `toggle` em <details> não borbulha de forma confiável — listener por item.
 */
(function () {
  function initFaq(root) {
    if (!root || root.dataset.gmFaqReady === '1') return;
    root.dataset.gmFaqReady = '1';

    const items = Array.from(root.querySelectorAll('details.gm-faq__item'));
    const groups = Array.from(root.querySelectorAll('.gm-faq__group-title'));
    const search = root.querySelector('[data-gm-faq-search]');
    const empty = root.querySelector('[data-gm-faq-empty]');

    const closeOthers = (opened) => {
      items.forEach((item) => {
        if (item !== opened && item.open) item.open = false;
      });
    };

    items.forEach((item) => {
      item.addEventListener('toggle', () => {
        if (item.open) closeOthers(item);
      });
    });

    // Fallback: alguns browsers atrasam o estado open no click do summary
    root.addEventListener('click', (event) => {
      const summary = event.target.closest
        ? event.target.closest('summary.gm-faq__summary')
        : null;
      if (!summary || !root.contains(summary)) return;
      const details = summary.closest('details.gm-faq__item');
      if (!details) return;
      queueMicrotask(() => {
        if (details.open) closeOthers(details);
      });
    });

    if (!search) return;

    const normalize = (value) =>
      String(value || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();

    const itemText = (item) => {
      const summary = item.querySelector('.gm-faq__summary');
      const answer = item.querySelector('.gm-faq__answer');
      return normalize(
        (summary ? summary.textContent : '') + ' ' + (answer ? answer.textContent : '')
      );
    };

    const refreshGroups = () => {
      groups.forEach((group) => {
        let sibling = group.nextElementSibling;
        let visibleCount = 0;
        while (sibling && !sibling.classList.contains('gm-faq__group-title')) {
          if (
            sibling.classList.contains('gm-faq__item') &&
            sibling.hidden !== true
          ) {
            visibleCount += 1;
          }
          sibling = sibling.nextElementSibling;
        }
        group.hidden = visibleCount === 0;
      });

      const anyVisible = items.some((item) => item.hidden !== true);
      if (empty) empty.hidden = anyVisible;
    };

    const applyFilter = () => {
      const query = normalize(search.value);
      items.forEach((item) => {
        const match = !query || itemText(item).includes(query);
        item.hidden = !match;
        if (!match) item.open = false;
      });
      refreshGroups();
    };

    search.addEventListener('input', applyFilter);
    search.addEventListener('search', applyFilter);
  }

  function boot() {
    document.querySelectorAll('[data-gm-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    if (!section || !section.querySelector) return;
    const root = section.querySelector('[data-gm-faq]');
    if (root) {
      delete root.dataset.gmFaqReady;
      initFaq(root);
    }
  });
})();
